import pdf from "../../assets/Resume_GUO_YICHEN(NTU)_shrink.pdf";

export const resumeData = {
  header: {
    name: "Guo Yichen (郭奕辰)",
    affiliation: [
      "Bachelor of Computing (Honours), Computer Science",
      "Nanyang Technological University, Singapore",
    ],
    contact: [
      {
        icon: "phone",
        text: "(+65) 8942 3938",
        href: "tel:+6589423938",
      },
      {
        icon: "mail",
        text: "YGUO017@e.ntu.edu.sg",
        href: "mailto:YGUO017@e.ntu.edu.sg",
      },
    ],
    links: [
      {
        icon: "website",
        href: "https://guoyichen.netlify.app/",
        label: "Homepage",
      },
      {
        icon: "linkedin",
        href: "https://www.linkedin.com/in/sunnyray114514/",
        label: "LinkedIn",
      },
      {
        icon: "github",
        href: "https://github.com/SunnyRaymond",
        label: "GitHub",
      },
      {
        icon: "pdf",
        href: pdf,
        label: "Download PDF Resume",
      },
    ],
  },

  abstract: {
    paragraphs: [
      'I am a Computer Science undergraduate at <a href="https://www.ntu.edu.sg/" target="_blank" rel="noreferrer">Nanyang Technological University</a>, currently building across full-stack engineering, intelligent interfaces, and applied AI systems.',
      "My recent work spans enterprise software engineering at <strong>ST Engineering</strong>, research-driven interface design as a <strong>Research Assistant at MICL Lab</strong>, and coursework across reinforcement learning, artificial intelligence, machine learning, and security.",
      "This page is reconstructed from my PDF resume into a more readable web CV, following the structure of the reference site while keeping the visual language aligned with my own portfolio.",
    ],
    keywords: [
      "Full-Stack Development",
      "Visual Analytics",
      "Machine Learning",
      "Human-Centered Interfaces",
    ],
  },

  sections: [
    {
      title: "Education",
      entries: [
        {
          title: "Nanyang Technological University, Singapore",
          date: "Aug 2023 - May 2027",
          detail: "Bachelor of Computing (Honours), Computer Science",
          items: [
            "Honors (Highest Distinction) | GPA 4.66 / 5.00 | Specialization in Artificial Intelligence | Dean's List for AY23/24",
            "Relevant Coursework: Reinforcement Learning, Data Structures and Algorithms, Artificial Intelligence",
          ],
        },
        {
          title: "University of Amsterdam, Netherlands",
          date: "Aug 2025 - Jan 2026",
          detail: "Exchange Student, Faculty of Science",
          items: [
            "GPA 8.63 / 10 | Singapore grading equivalent 5.0 / 5.0",
            "Relevant Coursework: Machine Learning, Computer Security, Multi-Agent System",
          ],
        },
      ],
    },
    {
      title: "Publications",
      entries: [
        {
          title: "Envisage: Towards Expressive Visual Graph Querying",
          date: "Nov 2024 - May 2025",
          detail: "IEEE TVCG (Proc. VIS 2025), Fourth Author",
          items: [
            "Proposed an interactive visual graph querying system to express complex and underspecified query intent with automated backend Cypher-level programming.",
            "Designed a four-stage pipeline: Query Expression -> Verification -> Progressive Execution -> Result Analysis for end-to-end query construction and validation.",
          ],
        },
      ],
    },
    {
      title: "Experience",
      entries: [
        {
          title: "ST Engineering, Singapore",
          date: "May 2025 - Aug 2025, Jan 2026 - Aug 2026",
          detail:
            "Software Engineer Intern, General Engineering Centre Data Analytics Department",
          items: [
            "Engineered and delivered end-to-end full-stack features for enterprise applications, improving data flow reliability while optimizing logic for performance, scalability, and maintainability.",
            "Worked hands-on on a Splunk to SQL + Tableau migration for SBST MRT operation data, reducing algorithmic redundancy across large-scale datasets and driving response times down to the second level.",
          ],
        },
        {
          title: "Nanyang Technological University, Singapore",
          date: "Aug 2024 - May 2025",
          detail: "Research Assistant at MICL Lab",
          items: [
            "Joined NTU's URECA undergraduate research program to develop an innovative visual analytics method around Web3 and emerging technology frontiers.",
            "Designed interactive, scalable interfaces with React.js for analyzing complex data networks, contributing to the lab's work on advanced data visualization techniques.",
          ],
        },
      ],
    },
    {
      title: "Project Work",
      entries: [
        {
          title: "Domain-Specific Text Classification via BERT Fine-Tuning",
          date: "Feb 2026",
          detail: "NLP Research Project",
          links: [
            {
              text: "Repository",
              href: "https://github.com/SunnyRaymond/CS224n-2024-Spring",
            },
          ],
          items: [
            "Fine-tuned a pretrained BERT model for text classification with tokenization, attention masking, and an end-to-end training pipeline on labeled NLP datasets.",
            "Designed and evaluated experiments across data preprocessing, hyperparameter tuning, and error analysis, then compared performance against neural baseline classifiers.",
          ],
        },
        {
          title: "Real-Time Full Stack Chat Application",
          date: "Jan 2025",
          detail: "Full-Stack Application",
          links: [
            {
              text: "Repository",
              href: "https://github.com/SunnyRaymond/NextJS-Chat-App",
            },
            {
              text: "Live Demo",
              href: "https://sunnyray-chat.vercel.app",
            },
          ],
          items: [
            "Built a real-time chat application with Next.js, React, Tailwind CSS, and TypeScript, including group chat, audio and video calls, and mobile-friendly workflows.",
            "Implemented Convex for real-time database updates and Clerk-based authentication, then deployed the experience to Vercel for a responsive cross-platform release.",
          ],
        },
      ],
    },
    {
      title: "Skills",
      subsections: [
        {
          title: "Programming",
          items: ["JavaScript, HTML5, CSS3, Python, Java, C, R"],
        },
        {
          title: "Full-Stack Development",
          items: [
            "React.js (Next.js), Tailwind CSS, Chrome browser plugin development, Node.js",
          ],
        },
        {
          title: "Data Analytics",
          items: [
            "Data visualization, data cleaning, machine learning with Pandas, NumPy, and TensorFlow",
          ],
        },
        {
          title: "Languages",
          items: [
            "Proficient in English and Chinese, with intermediate French",
          ],
        },
      ],
    },
  ],
};
